export const FILTER_TYPE = {
  FUNDAMENTAL_SKILL: {
    id: '6149b372fe2fb6c052919d53',
    title: 'Fundamentals / motor skills',
  },
  SKILL: {
    id: '6149b372fe2fb6c052919d51',
    title: 'Skill',
  },
  ATHLETICS_DISCIPLINE: {
    id: '6149b372fe2fb6c052919d52',
    title: 'Athletics discipline',
  },
  KIDS_ATHLETICS_VALUE: {
    id: '6149b372fe2fb6c052919d54',
    title: 'Kids’ Athletics Values',
  },
  AGE_GROUP: {
    id: '6149b372fe2fb6c052919d4f',
    title: 'Levels',
  },
  RESOURCE_TYPE: {
    id: '6149b372fe2fb6c052919d50',
    title: 'Resource type',
  },
  CONTENT_TRACK: {
    id: '6149b372fe2fb6c052919d55',
    title: 'Content Track',
  },
  SUGGESTED_GRADE_LEVEL: {
    id: '6149b372fe2fb6c052919d56',
    title: 'Suggested grade level',
  },
  SUBJECT_AREA: {
    id: '6149b372fe2fb6c052919d57',
    title: 'Subject area',
  },
  TRACK_FIELD_FOCUS: {
    id: '6149b372fe2fb6c052919d58',
    title: `Track & field focus`,
  },
  ACTIVITY_SPACE: {
    id: '6149b372fe2fb6c052919d59',
    title: 'Activity space',
  },
  ACTIVITY_TYPE: {
    id: '6149b372fe2fb6c052919d5a',
    title: 'Activity Type',
  },
  MEDICAL_CARE: {
    id: '629892802468c698b1e3a55e',
    title: 'Medical Care',
  },
  RISK_MITIGATION: {
    id: '629892884c5bd6f3996b4917',
    title: 'Risk Mitigation',
  },
  TRAINING_AND_PERFORMANCE: {
    id: '629892b175ba50bd4c952bf3',
    title: 'Training & Performance',
  },
  ENVIRONMENT: {
    id: '629892d60e1414c754e5c693',
    title: 'Environment',
  },
  SPECIAL_POPULATIONS: {
    id: '629892e6e41afe23ddca1390',
    title: 'Special Populations',
  },
};
